export default () => (/**
* Icone de duas setas em círculo.
* Responsável por criar desenho.
* Encontrada na ferramenta de inserir coordenadas.
*/
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4621 6.3002H11.4621C11.2499 6.3002 11.0465 6.21591 10.8964 6.06588C10.7464 5.91585 10.6621 5.71237 10.6621 5.5002C10.6621 5.28802 10.7464 5.08454 10.8964 4.93451C11.0465 4.78448 11.2499 4.7002 11.4621 4.7002H14.6621V1.5002C14.6621 1.28802 14.7464 1.08454 14.8964 0.93451C15.0465 0.784481 15.2499 0.700195 15.4621 0.700195C15.6743 0.700195 15.8778 0.784481 16.0278 0.93451C16.1778 1.08454 16.2621 1.28802 16.2621 1.5002V5.5002C16.2621 5.71237 16.1778 5.91585 16.0278 6.06588C15.8778 6.21591 15.6743 6.3002 15.4621 6.3002Z"
      fill="#BEC7DC"
    />
    <path
      d="M1.27115 7.2351L1.26624 7.22608L1.26095 7.21727C1.23088 7.16715 1.21642 7.08823 1.23446 7.01608L1.23462 7.01612L1.23743 7.00351C1.99735 3.59163 5.00504 1.2002 8.53407 1.2002C11.0139 1.2002 13.2669 2.40672 14.6549 4.36054L14.7135 4.66999L14.1225 4.56615C12.8418 2.82714 10.7787 1.75713 8.53407 1.75713C5.27741 1.75713 2.49079 3.94691 1.77162 7.12054C1.72117 7.29352 1.56919 7.3686 1.43135 7.33666C1.33449 7.31187 1.28783 7.26566 1.27115 7.2351Z"
      stroke="#BEC7DC"
    />
    <path
      d="M1.52617 11.1002L5.52617 11.1002C5.73835 11.1002 5.94183 11.1845 6.09186 11.3345C6.24189 11.4845 6.32617 11.688 6.32617 11.9002C6.32617 12.1124 6.24189 12.3159 6.09186 12.4659C5.94183 12.6159 5.73835 12.7002 5.52617 12.7002L2.32617 12.7002L2.32617 15.9002C2.32617 16.1124 2.24189 16.3159 2.09186 16.4659C1.94183 16.6159 1.73834 16.7002 1.52617 16.7002C1.314 16.7002 1.11051 16.6159 0.960485 16.4659C0.810456 16.3159 0.726172 16.1124 0.726172 15.9002L0.726172 11.9002C0.726172 11.688 0.810457 11.4845 0.960486 11.3345C1.11052 11.1845 1.314 11.1002 1.52617 11.1002Z"
      fill="#BEC7DC"
    />
    <path
      d="M15.7171 10.1653L15.722 10.1743L15.7273 10.1831C15.7574 10.2332 15.7719 10.3122 15.7538 10.3843L15.7537 10.3843L15.7508 10.3969C14.9909 13.8088 11.9832 16.2002 8.45421 16.2002C5.97433 16.2002 3.72136 14.9937 2.33335 13.0398L2.27475 12.7304L2.8658 12.8342C4.14646 14.5732 6.20963 15.6433 8.45421 15.6433C11.7109 15.6433 14.4975 13.4535 15.2167 10.2799C15.2671 10.1069 15.4191 10.0318 15.5569 10.0637C15.6538 10.0885 15.7005 10.1347 15.7171 10.1653Z"
      stroke="#BEC7DC"
    />
  </svg>
);
